import { get } from 'lodash';

import { EMPTY_OBJ } from 'Services/constants/empty';

export default (state) => {
  const currentRouteType = get(state, ['Location', 'type']);
  const routesMap = get(state, ['Location', 'routesMap'], EMPTY_OBJ);
  if (get(state, ['Meeting', 'chimeMeeting']) && get(routesMap, [currentRouteType, 'hasMeetingProtection'])) {
    return 'Are you sure you want to leave while you are in a consult?';
  }
  return void 0;
};
